'use strict';

import angular from 'angular';
import appConfigShared from '../../server/config/environment/shared.js';

export default angular.module('georgeApp.constants', [])
  .constant('appConfig', appConfigShared)
  .name;
